import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { sdsColors, sdsRadius } from '../theme/solutionsDesignSystem';

// A compact vertical card (colored rail, image, then title/description/link)
// — sits in a grid instead of a stack of full-width horizontal rows. Colors
// match the Solutions page's design system for a consistent look across
// both pages.
const useStyles = makeStyles(() => ({
    card: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #E6E9EE',
        borderRadius: 20,
        textDecoration: 'none',
        color: 'inherit',
        background: '#FFFFFF',
        overflow: 'hidden',
        transition: 'transform 400ms cubic-bezier(.32,.72,0,1), box-shadow 400ms cubic-bezier(.32,.72,0,1)',
        '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: '0 24px 60px rgba(23,41,57,0.10)',
        },
    },
    imageWrap: {
        position: 'relative',
        width: '100%',
        aspectRatio: '16/10',
        overflow: 'hidden',
        background: '#F4F3F1',
    },
    image: {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        padding: '24px 24px 26px',
        flex: 1,
    },
    title: {
        fontSize: 22,
        lineHeight: 1.2,
        letterSpacing: '-0.02em',
        fontWeight: 800,
        color: '#1B2430',
        margin: 0,
        fontFamily: "'Figtree', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    description: {
        fontSize: 15,
        lineHeight: 1.6,
        margin: 0,
        color: '#5B6470',
        flex: 1,
        fontFamily: "'Figtree', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    linkLabel: {
        fontSize: 15,
        fontWeight: 700,
        color: '#A63C0C',
        marginTop: 4,
        fontFamily: "'Figtree', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
}));

const PbdqOutcomeCard = ({ title, description, linkLabel, to, image, imageAlt, railColor }) => {
    const classes = useStyles();

    return (
        <Link to={to} className={classes.card} style={railColor ? { borderLeft: `4px solid ${railColor}` } : undefined}>
            <div className={classes.imageWrap}>
                <img src={image} alt={imageAlt} className={classes.image} />
            </div>
            <div className={classes.body}>
                <h3 className={classes.title}>{title}</h3>
                <p className={classes.description}>{description}</p>
                <span className={classes.linkLabel}>{linkLabel} →</span>
            </div>
        </Link>
    );
};

export default PbdqOutcomeCard;
